/* One Ajax payload per bundle. Discounts are administered in Shopify, never created here. */
if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
window.addEventListener('pageshow', event => {
  const navigation = performance.getEntriesByType?.('navigation')?.[0];
  if (!event.persisted && navigation?.type !== 'back_forward' && !location.hash) {
    requestAnimationFrame(() => window.scrollTo(0, 0));
  }
}, {once:true});

if (!customElements.get('tdd-buybox')) customElements.define('tdd-buybox', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const requested = new URLSearchParams(location.search).get('tier');
    this.tiers = [...this.querySelectorAll('[data-tier]')].filter(t => !t.hidden);
    this.selected = this.tiers.find(t => t.dataset.tier === requested && !t.disabled) || this.tiers.find(t => t.dataset.tier === this.dataset.default && !t.disabled) || this.tiers.find(t => !t.disabled);
    this.tiers.forEach((tier, index) => {
      tier.addEventListener('click', () => { this.selected = tier; this.update(); });
      tier.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const enabled = this.tiers.filter(t => !t.disabled);
        let next = enabled.indexOf(tier) + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = enabled.length - 1;
        this.selected = enabled[(next + enabled.length) % enabled.length];
        this.update(); this.selected?.focus();
      });
    });
    this.querySelector('[data-gift]')?.addEventListener('change', () => this.update());
    this.galleryTrack = this.querySelector('[data-gallery-track]');
    this.gallerySlides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.galleryThumbs = [...this.querySelectorAll('[data-thumb]')];
    this.loadGallerySlide = index => {
      const image = this.gallerySlides[index]?.querySelector('img[data-src]');
      if (!image) return;
      image.loading = 'eager';
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      delete image.dataset.src;
      delete image.dataset.srcset;
    };
    // Prioritise the cover, then prepare every photo without waiting for a swipe.
    this.galleryCover = this.gallerySlides[0]?.querySelector('img');
    this.preloadGallery = () => {
      this.gallerySlides.forEach((slide, index) => this.loadGallerySlide(index));
    };
    if (!this.galleryCover || this.galleryCover.complete) {
      this.preloadGallery();
    } else {
      this.galleryCover.addEventListener('load', this.preloadGallery, {once:true});
      this.galleryCover.addEventListener('error', this.preloadGallery, {once:true});
    }
    this.setGalleryIndex = index => {
      const bounded = Math.max(0, Math.min(index, this.gallerySlides.length - 1));
      this.loadGallerySlide(bounded);
      this.galleryThumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-pressed', String(thumbIndex === bounded)));
    };
    this.galleryThumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const index = Number(thumb.dataset.galleryIndex || 0);
      const slide = this.gallerySlides[index];
      if (!this.galleryTrack || !slide) return;
      this.loadGallerySlide(index);
      this.loadGallerySlide(index + 1);
      this.galleryTrack.scrollTo({left:slide.offsetLeft,behavior:'smooth'});
      this.setGalleryIndex(index);
    }));
    if (this.galleryTrack && this.gallerySlides.length > 1) {
      this.prepareGallerySwipe = () => {
        const index = Math.round(this.galleryTrack.scrollLeft / Math.max(1, this.galleryTrack.clientWidth));
        this.loadGallerySlide(index - 1);
        this.loadGallerySlide(index + 1);
      };
      this.galleryTrack.addEventListener('pointerdown', this.prepareGallerySwipe, {passive:true});
      this.galleryTrack.addEventListener('keydown', this.prepareGallerySwipe);
      this.syncGallery = () => {
        if (this.galleryFrame) return;
        this.galleryFrame = requestAnimationFrame(() => {
          const index = Math.round(this.galleryTrack.scrollLeft / Math.max(1, this.galleryTrack.clientWidth));
          this.setGalleryIndex(index);
          this.loadGallerySlide(index - 1);
          this.loadGallerySlide(index + 1);
          this.galleryFrame = null;
        });
      };
      this.galleryTrack.addEventListener('scroll', this.syncGallery, {passive:true});
      this.setGalleryIndex(0);
    }
    this.querySelector('[data-sticky-atc]')?.addEventListener('click', () => this.add());
    const sticky = this.querySelector('[data-sticky-buy]');
    const mainButton = this.querySelector('[data-atc]');
    if (sticky && mainButton) {
      this.syncSticky = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          sticky.hidden = mainButton.getBoundingClientRect().bottom > 90;
          this.stickyFrame = null;
        });
      };
      window.addEventListener('scroll', this.syncSticky, {passive:true});
      window.addEventListener('resize', this.syncSticky);
      this.syncSticky();
    }
    // Capture at the form before Dawn's native product-form bubble listener can send a second request.
    this.querySelector('form.tdd-product-form').addEventListener('submit', event => {
      event.preventDefault(); event.stopImmediatePropagation(); this.add();
    }, true);
    window.TDDDates?.render(this);
    this.update();
  }
  money(cents, currency = false) {
    const code = this.dataset.currency || 'AUD';
    const amount = new Intl.NumberFormat('en-AU',{style:'currency',currency:code,currencyDisplay:'narrowSymbol'}).format(cents / 100);
    return amount + (currency ? ' ' + code : '');
  }
  update() {
    this.tiers.forEach(t => { const on = t === this.selected; t.setAttribute('aria-checked', String(on)); t.tabIndex = on ? 0 : -1; });
    const atc = this.querySelector('[data-atc]');
    const stickyButton = this.querySelector('[data-sticky-atc]');
    if (!this.selected) { atc.disabled = true; atc.textContent = 'Sold out'; if (stickyButton) { stickyButton.disabled = true; stickyButton.textContent = 'Sold out'; } return; }
    const gift = this.querySelector('[data-gift]:checked');
    this.total = Number(this.selected.dataset.price) + Number(gift?.dataset.price || 0);
    const compare = Number(this.selected.dataset.compare) + Number(gift?.dataset.price || 0);
    this.querySelector('[data-total]').textContent = this.money(this.total, true);
    const bnpl = this.querySelector('[data-bnpl]'); if (bnpl) bnpl.textContent = this.money(Math.round(this.total / 4));
    const was = this.querySelector('[data-compare]'); was.textContent = this.money(compare, true); was.hidden = compare <= this.total;
    const save = this.querySelector('[data-save]'); if (save) { save.hidden = compare <= this.total; save.textContent = compare > 0 ? `SAVE ${Math.round((compare-this.total)*100/compare)}%` : ''; }
    atc.disabled = this.busy === true; atc.textContent = `Add to cart — ${this.money(this.total)}`;
    if (stickyButton) {
      stickyButton.disabled = this.busy === true; stickyButton.textContent = this.busy ? 'Adding…' : 'Add to cart';
      this.querySelector('[data-sticky-price]').textContent = this.money(this.total, true);
      this.querySelector('[data-sticky-label]').textContent = this.selected.querySelector('strong').textContent;
    }
  }
  async add() {
    if (this.busy || !this.selected) return;
    this.busy = true;
    const button = this.querySelector('[data-atc]'); button.disabled = true; button.setAttribute('aria-busy','true');
    this.update();
    const error = this.querySelector('[data-error]'); error.hidden = true;
    try {
      const mode = this.selected.dataset.tier;
      const items = [{id:Number(this.dataset.variant),quantity:mode === 'triple' ? 3 : mode === 'double' ? 2 : 1}];
      if (mode === 'pair') items.push({id:Number(this.dataset.otherVariant),quantity:1});
      const gift = this.querySelector('[data-gift]:checked');
      if (gift) { const same = items.find(i => i.id === Number(gift.dataset.variant)); if (same) same.quantity++; else items.push({id:Number(gift.dataset.variant),quantity:1}); }
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement(document.activeElement);
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:drawer?.getSectionsToRender().map(s=>s.id) || ['cart-drawer','cart-icon-bubble'],sections_url:location.pathname + location.search})});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add this bundle. Please try again.');
      if (drawer) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'tdd-buybox',productVariantId:this.dataset.variant,cartData:data});
      document.dispatchEvent(new CustomEvent('tdd:cart-added',{detail:{items}}));
    } catch (e) { error.textContent = e.message; error.hidden = false; error.scrollIntoView({block:'center',behavior:'smooth'}); }
    finally { this.busy = false; button.removeAttribute('aria-busy'); this.update(); }
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.syncSticky);
    window.removeEventListener('resize', this.syncSticky);
    cancelAnimationFrame(this.stickyFrame);
    this.galleryTrack?.removeEventListener('scroll', this.syncGallery);
    this.galleryTrack?.removeEventListener('pointerdown', this.prepareGallerySwipe);
    this.galleryTrack?.removeEventListener('keydown', this.prepareGallerySwipe);
    cancelAnimationFrame(this.galleryFrame);
    this.galleryCover?.removeEventListener('load', this.preloadGallery);
    this.galleryCover?.removeEventListener('error', this.preloadGallery);
  }
});
